import { Base } from '@studiometa/js-toolkit';

/**
 * AbstractScrollRevealChild class is a base class for all scroll reveal child elements.
 */
export default class AbstractScrollRevealChild extends Base {
  /**
   * Class mounted.
   */
  mounted() {
    throw new Error('this must be implemented');
  }
}
